import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import WithholdingTaxIndexPage from '../containers/WithholdingTaxes'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const WithholdingTaxesPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'withholding_taxes') {
			dispatch(changeCurrent(['withholding_taxes']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={WithholdingTaxIndexPage} exact />
		</Switch>
  )
}

WithholdingTaxesPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

WithholdingTaxesPage.defaultProps = {}

export default WithholdingTaxesPage
